/** 网络、接口 相关配置 **/
export const config = {
  apiUserRegisterMobileCodePath: "/api/user/register/mobile/code", // 获取验证码
  apiUserRegisterCodeValidatePath: "/api/user/register/code/validate", // 验证验证码
  apiUserRegisterTemregistPath: "/api/user/register/temregist ", // 注册
  apiUserRegisterTemregistUpdatePath: "/api/user/register/temregistupdate ", // 完善信息
  buryPointRegisterMonitorAddRegisterCodePointPath: "burypoint/register/monitor/addRegisterCodePoint", //获取验证码埋点
  buryPointRegisterMonitorUpdateRegisterCodePointPath: "burypoint/register/monitor/updateRegisterCodePoint", //注册成功埋点
  buryPointInsertRecordPath: "/burypoint/user/behavior/insertRecord", //400弹窗埋点
  restUCompanyGetCompanyInfoPath: "/rest/u/company/getCompanyInfo", // 获取用户信息
  restUserApiHomepageLogoutPath: "/user/logout", //退出登录
  commonCusApiHomepageIdTypeGwPath: "/common/cus/api/homepage/idTypeGw", // 定制版会员中心入口显示
  restPayPayDialogInfoNeedBuyMoreDialogPath: "/rest/pay/pay/dialog/info/needBuyMoreDialog",
  // 埋点
  userBehaviorInsertRecordWebsitePath: "/user/behavior/insertRecordWebsite", //公共埋点

  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    NO_AUTHORISE: 403,
    REDO_LOGIN: 406,
    ACCESS_CAPTCHA_PERMISSION_429: 429,
    TOO_FREQUENTLY_521: 521,
  },

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
    TO_SUBSCRIBE: 500500,
    REQUEST_CANCEL: "REQUEST_CANCEL",
    PERMISSION_EXPIRATION: 310300, // 权限过期
    ACCESS_CAPTCHA_PERMISSION_IS_MISSING: 200622, // 需要滑动验证刷新权限
  },
};
